// Real Google Business Profile reviews for Fitness Training 360.
// Source: Google Business listing (provided by owner).
//
// INTEGRITY NOTE: Two 5-star Google reviews (Sallie Snyder, Maureen Cotter)
// were intentionally omitted because their text names the previous owner.
// The current site reflects current ownership (Jarad Wingard) only.

export const GOOGLE_REVIEWS_URL = 'https://share.google/dr6YSQ17tjiCBBt55';

// Visible, on-site reviews. Reviews without text are shown as "rated 5★ on Google" cards.
export const REVIEWS = [
  {
    id: 'danyella-lustosa',
    name: 'Danyella Lustosa',
    rating: 5,
    relativeDate: '2 years ago',
    role: '11 reviews',
    text: 'Beautiful space friendly owners and great teachers. Stop by and try one of the group classes.',
    source: 'Google',
  },
  {
    id: 'dana-ohara-smith',
    name: 'Dana O’Hara Smith',
    rating: 5,
    relativeDate: '4 years ago',
    role: 'Local Guide · 32 reviews · 1 photo',
    text: 'Great studio!',
    source: 'Google',
  },
  {
    id: 'jess-almeter',
    name: 'Jess Almeter',
    rating: 5,
    relativeDate: '11 months ago',
    role: 'Local Guide · 13 reviews · 9 photos',
    text: '',
    source: 'Google',
  },
  {
    id: 'kelly-lavalle',
    name: 'Kelly LaValle',
    rating: 5,
    relativeDate: '2 years ago',
    role: 'Local Guide · 13 reviews · 6 photos',
    text: '',
    source: 'Google',
  },
];

// Friendly fallback rendered when a review has no text (rating-only on Google).
export const RATING_ONLY_FALLBACK = 'Rated us 5 stars on Google.';
